import { HYDRATE } from 'next-redux-wrapper';

import { EWifiActions } from '~/src/features/wifi/store/actions/constants';
import { InferValueTypes, THydrateAction } from '~/src/store';

import * as actions from './actions';
import { initialState } from './initialState';

type TActions = ReturnType<InferValueTypes<typeof actions>> | THydrateAction;

export const wifiReducer = (state = initialState, action: TActions) => {
    switch (action.type) {
        case HYDRATE: {
            return {
                ...state,
                ...action.payload.wifi,
            };
        }
        case EWifiActions.FETCH_WIFI: {
            return {
                ...state,
                fetching: true,
            };
        }
        case EWifiActions.ERROR_WIFI: {
            return {
                ...state,
                fetching: false,
                fetchError: action.payload.error,
            };
        }
        case EWifiActions.SET_WIFI: {
            return {
                ...state,
                fetching: false,
                items: action.payload.points,
            };
        }
        case EWifiActions.CHANGE_CONTACT: {
            return {
                ...state,
                selectedContact: action.payload.contact,
            };
        }
        case EWifiActions.CHANGE_CATEGORY: {
            return {
                ...state,
                selectedCategory: action.payload.category,
            };
        }
        default: {
            return state;
        }
    }
};
